<h3 mat-dialog-title >
    <b>Receita</b> 
</h3>
<div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
    <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
        <mat-label>Descrição</mat-label>
        <input 
            matInput 
            placeholder="Descrição"
            aria-label="Descrição" 
            [formControl]="descricao" 
            required
            maxlength="255">
    </mat-form-field>
</div>
<div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
    <mat-form-field appearance="outline" floatLabel="always" style="width: 100%" fxFlex="100">
       <mat-label>Tipo de Receita</mat-label>
       <mat-select
            [(value)]="model.tipo_receita_id"
            [formControl]="tipo_receita_id">
            <mat-option value="">SELECIONE</mat-option>
            <mat-option *ngFor="let tipoReceita of listaTipoReceita"
                [value]="tipoReceita.id">{{tipoReceita.descricao}}</mat-option>
       </mat-select>
       <mat-spinner diameter="20" *ngIf="loadingSpinnerTipoReceita"></mat-spinner> 
    </mat-form-field>
</div>
<div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
    <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
        <mat-label>Valor</mat-label>
        <input matInput placeholder="Valor" [formControl]="valor"
            name="valor" maxlength="255" currencyMask
            [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }">
    </mat-form-field>
</div>

 <div mat-dialog-actions style="text-align: center; margin-top: 20px;">
     <button 
         mat-button 
         tabindex="2" 
         (click)="onNoClick()">
         Cancelar
     </button>
     <button 
         mat-button 
         [disabled]="isInvalidForm()" 
         (click)="salvar()" 
         tabindex="-1">
         Confirmar
     </button>
 </div>